import React from 'react';
import { Page } from '../Page';
export function PageDoseManagement2() {
  return <Page pageNumber={6} variant="light" data-id="element-939">
      <div className="flex flex-col h-full" data-id="element-940">
        <div className="grid grid-cols-2 gap-10 flex-1 mt-2" data-id="element-941">
          {/* Left Column - fills to the bottom */}
          <div className="flex flex-col space-y-4" data-id="element-942">
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-943">
              That's useful feedback. It doesn't automatically mean you need to
              increase, but it can be a sign that your current dose isn't
              lasting the full week.
            </p>

            {/* Zepbound Dose Progression Image */}
            <div className="py-1" data-id="element-944">
              <img src="https://cdn.magicpatterns.com/uploads/94D4dNseC7uLTKHQ9PqeHn/zepbound_transparent.png" alt="Dose Progression (Zepbound) - 2.5mg to 15mg" className="w-full h-auto object-contain" data-id="element-945" />
            </div>

            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-946">
              If you're already losing weight, eating well, and your hunger
              feels under control, there's no clear benefit to increasing just
              because it's time. In some cases, increasing too quickly can lead
              to more side effects without improving your results.
            </p>
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-947">
              On the other hand, if progress has stalled for several weeks or
              hunger and food noise are still getting in the way, that's when
              increasing the dose can make a real difference.
            </p>
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-948">
              A lower effective dose usually means fewer side effects, better
              nutrition, and a smoother transition when it's time to come off
              the medication.
            </p>
          </div>

          {/* Right Column - overflow */}
          <div className="flex flex-col space-y-4" data-id="element-949">
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-950">
              It also makes the whole process easier to sustain, which is what
              actually drives long-term results.
            </p>
          </div>
        </div>
      </div>
    </Page>;
}